import React, { ChangeEvent } from 'react';
import { Input, Select, DatePicker, TimePicker } from 'antd';
import moment from 'moment';

interface InviteMemberCellProps {
	className: string;
	memberships: Array<{ id: number; type: string }>;
	onChange?: (value: {
		name: string;
		email: string;
		membership_id: number;
		start_datetime?: Date;
	}) => void;
}

export default class InviteMemberCell extends React.Component<InviteMemberCellProps> {
	name = '';
	email = '';
	membership_id = 0;
	start_datetime?: Date;
	today = moment();

	render() {
		const { className, memberships } = this.props;
		const showMembershipOption = memberships.length > 1;
		const nameWidth = showMembershipOption ? '15%' : '22%';
		const emailWidth = showMembershipOption ? '30%' : '45%';

		return (
			<Input.Group compact className={className}>
				<Input
					placeholder="Name"
					style={{ width: nameWidth }}
					onChange={this._onChangeName}
				/>
				<Input
					placeholder="Email"
					style={{ width: emailWidth }}
					onChange={this._onChangeEmail}
				/>
				<DatePicker
					format="DD.MMM.YYYY HH:mm"
					placeholder="Start datetime"
					disabledDate={this._disabledStartDate}
					showTime={{
						format: 'HH:mm',
						minuteStep: 15,
						disabledHours: this._disableHours
					}}
					onChange={this._onStartTimeChange}
				/>
				{showMembershipOption && (
					<Select
						placeholder="Membership"
						style={{ width: '23%' }}
						onChange={this._onSelectMembershipType}
					>
						{this.props.memberships.map(membership => (
							<Select.Option value={membership.id} key={membership.id}>
								{membership.type}
							</Select.Option>
						))}
					</Select>
				)}
			</Input.Group>
		);
	}

	_disabledStartDate = (date: any) => {
		return date.isBefore(this.today);
	};

	_disableHours = (): Array<number> => {
		return [0, 1, 2, 3, 4, 5, 6, 19, 20, 21, 22, 23];
	};

	_onChangeName = (e: ChangeEvent<HTMLInputElement>) => {
		this.name = e.target.value;
		const value = {
			name: this.name,
			email: this.email,
			membership_id: this.getMembershipId(),
			start_datetime: this.start_datetime
		};
		this.props.onChange && this.props.onChange(value);
	};

	_onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
		this.email = e.target.value;
		const value = {
			name: this.name,
			email: this.email,
			membership_id: this.getMembershipId(),
			start_datetime: this.start_datetime
		};
		this.props.onChange && this.props.onChange(value);
	};

	_onSelectMembershipType = (membership_id: number) => {
		this.membership_id = membership_id;
		const value = {
			name: this.name,
			email: this.email,
			membership_id: this.membership_id,
			start_datetime: this.start_datetime
		};
		this.props.onChange && this.props.onChange(value);
	};

	_onStartTimeChange = (date: any) => {
		this.start_datetime = date ? date.second(0).toDate() : undefined;
		const value = {
			name: this.name,
			email: this.email,
			membership_id: this.getMembershipId(),
			start_datetime: this.start_datetime
		};
		this.props.onChange && this.props.onChange(value);
	};

	private getMembershipId = () => {
		const { memberships } = this.props;
		return memberships.length === 1 ? memberships[0].id : this.membership_id;
	};
}
